export default "__VITE_ASSET__BXc75szd__"